import { Provider } from '@angular/core';
import { PARTICIPANTE_REPOSITORY } from './repositories/participante.repository';
import { ParticipanteService } from './services/participante.service';

export const PARTICIPANTE_PROVIDERS: Provider[] = [
  {
    provide: PARTICIPANTE_REPOSITORY,
    useClass: ParticipanteService
  }
];


